import PHDASSETS_EXT_1 from "./PHDASSETS_EXT_1";
export default {
  PHDASSETS_EXT_1,
};
